import React from "react";

const RevealConfirmArticleSection = (props) => {
  return (
    <div className="reveal-confirm-article-container">
      <div className="title">反社会的勢力に関する表明・確約条項</div>
      <div className="text">
        私（本取引の名義人）は、次の１．の各号のいずれかに該当し、もしくは2.の各号のいずれかに該当する行為をし、または１．にもとづく表明・確約に関して虚偽の申告をしたことが判明した場合には、この預金等取引が停止され、または通知によりこの預金等取引が解約されても異議を申しません。また、これにより損害が生じた場合でも、いっさい私の責任とします。
        <br />
        <br />
        １．
        私は、現在、暴力団、暴力団員、暴力団員でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる者（以下これらを「暴力団員等」といいます。）に該当しないこと、および次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約いたします。
        <br />
        <br />
        （１） 暴力団員等が経営を支配していることが認められる関係を有すること
        <br />
        （２）
        暴力団員等が経営に実質的に関与していると認められる関係を有すること
        <br />
        （３）
        自己、自社もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不当に暴力団員等を利用していると認められる関係を有すること
        <br />
        （４）
        暴力団員等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係
        <br />
        （５）
        役員または経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること
        <br />
        <br />
        ２．
        自らまたは第三者を利用して次のいずれか一にでも該当する行為を行わないことを確約いたします。
        <br />
        <br />
        （１） 暴力的な要求行為
        <br />
        （２） 法的な責任を超えた不当な要求行為
        <br />
        （３） 取引に関して、脅迫的な言動をし、または暴力を用いる行為
        <br />
        （４）
        風説を流布し、偽計を用いまたは威力を用いて当行の信用を毀損し、または当行の業務を妨害する行為
        <br />
        （５） その他前各号に準ずる行為
      </div>
      <br />
      <div className="text right">以上</div>
    </div>
  );
};

export default RevealConfirmArticleSection;
